import { Paper, Typography } from "@mui/material";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { useUserData } from "src/context/userContext";
import { useStatData } from "src/context/StatContext";

export const Stat_StatisticsChart1 = () => {
  const { userAsiakas } = useUserData();
  const { data } = useStatData();
  if (!userAsiakas) return null;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        padding: 16,
        gap: 8,
      }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 8,
        }}>
        <Typography variant="h5">Kuukausi tilasto 2024 </Typography>
        <Typography variant="h5">{userAsiakas.asiakasNimi}</Typography>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", flexDirection: "row", gap: 6 }}>
        {}
        <Paper
          elevation={3}
          style={{ flex: 1, minWidth: "300px", height: "400px", padding: "10px" }}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line type="monotone" dataKey="asiakasCount" stroke="#8884d8" name="Asiakas lkm" />
              <Line type="monotone" dataKey="tyomaaCount" stroke="#ff7300" name="Työmaa lkm" />
              <Line
                activeDot={{ r: 8 }}
                type="monotone"
                dataKey="keikkaCount"
                stroke="#ffc658"
                name="Tilaus lkm"
              />
              {/* <Line type="monotone" dataKey="palkkiCount" stroke= name="Palkkien määrä" /> */}
              {/* <Line type="monotone" dataKey="keikkaMinutes" stroke="#ffbb00" name="Trip Minutes" /> */}
            </LineChart>
          </ResponsiveContainer>
        </Paper>
        <Paper
          elevation={3}
          style={{ flex: 1, minWidth: "300px", height: "400px", padding: "10px" }}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line
                activeDot={{ r: 8 }}
                type="monotone"
                dataKey="kuskiCount"
                stroke="#ffc658"
                name="Kuljettajien lkm"
              />
              <Line
                type="monotone"
                dataKey="vehicleCount"
                stroke="#ff7300"
                name="Ajoneuvojen lkm"
              />
              {/* <Line type="monotone" dataKey="keikkaMinutes" stroke="#ffbb00" name="Trip Minutes" /> */}
            </LineChart>
          </ResponsiveContainer>
        </Paper>
      </div>
    </div>
  );
};

export default Stat_StatisticsChart1;
